/*
 * AISummaryAssistantPanel Messages
 *
 * This contains all the text for the AISummaryAssistantPanel component.
 */
import { defineMessages } from 'react-intl';

const scope = 'app.workspace.AISummaryAssistant';

export default defineMessages({
  summaryAssistant: {
    id: `${scope}.summaryAssistant`,
    defaultMessage: 'AI Summary Assistant',
  },
  tilte: {
    id: `${scope}.tilte`,
    defaultMessage: 'AI Assistant',
  },
  history: {
    id: `${scope}.history`,
    defaultMessage: 'Chat History',
  },
  clearHistory: {
    id: `${scope}.clearHistory`,
    defaultMessage: 'Clear History',
  },
  promptLibrary: {
    id: `${scope}.promptLibrary`,
    defaultMessage: 'Prompt Library',
  },
  feedback: {
    id: `${scope}.feedback`,
    defaultMessage: 'Send Feedback',
  },
  welcomeMessage: {
    id: `${scope}.welcomeMessage`,
    defaultMessage: 'Hello 👋 I can help you generate this Lesson Summary, you can modify it, retry or insert it to the workspace.',
  },
  welcomeMessageTranslation: {
    id: `${scope}.welcomeMessageTranslation`,
    defaultMessage: 'Hello 👋 I can help you generate Translation, you can insert it to the workspace.',
  },
  summaryTitle: {
    id: `${scope}.summaryTitle`,
    defaultMessage: 'To start, please choose the Summary options you want and then continue',
  },
  translationTitle: {
    id: `${scope}.translationTitle`,
    defaultMessage: 'To start, please choose the Translation options you want and then continue',
  },
  footerText: {
    id: `${scope}.footerText`,
    defaultMessage: 'This tool uses AI, which is an evolving technology. Don’t share personal data and check the output for accuracy. For more information see our ',
  },
  footerTextLink: {
    id: `${scope}.footerTextLink`,
    defaultMessage: 'FAQs',
  },
  loadMessage: {
    id: `${scope}.loadMessage`,
    defaultMessage: 'Great! Thanks for your prompt. Give me a moment to generate the Summary.',
  },
  caseStudyLoadMessage: {
    id: `${scope}.loadMessage`,
    defaultMessage: 'Great! Thanks for your prompt. Give me a moment to generate the Case study.',
  },
  featureBoxLoadMessage: {
    id: `${scope}.featureBoxLoadMessage`,
    defaultMessage: 'Great! Thanks for your prompt. Give me a moment to generate the "Local Lens" feature.',
  },
  translationLoadMessage: {
    id: `${scope}.loadMessage`,
    defaultMessage: 'Great! Give me a moment to generate the Translation.',
  },
  summaryMessage: {
    id: `${scope}.summaryMessage`,
    defaultMessage: 'Here’s the summary, based on your preferences. Please review it, insert it or retry.',
  },
  editMessage: {
    id: `${scope}.editMessage`,
    defaultMessage: 'The prompt has been added to the textbox below. You can edit it and enter it to generate a new Summary.',
  },
  caseStudyEditMessage: {
    id: `${scope}.caseStudyEditMessage`,
    defaultMessage: 'The prompt has been added to the textbox below. You can edit it and enter it to generate a new Case study.',
  },
  featureBoxEditMessage: {
    id: `${scope}.featureBoxEditMessage`,
    defaultMessage: 'The prompt has been added to the textbox below. You can edit it and enter it to generate a new Feature Box.',
  },

  screenSuccess: {
    id: `${scope}.copy.screen.success`,
    defaultMessage: 'Generated Content was copied.',
  },

  historySearch: {
    id: `${scope}.historySearch`,
    defaultMessage: 'Filter by chat title...',
  },
  caseStudy: {
    id: `${scope}.caseStudy`,
    defaultMessage: 'Generate a Company Case',
  },
  generateFeatureBox: {
    id: `${scope}.generateFeatureBox`,
    defaultMessage: 'Generate a "Local Lens" feature',
  },
  translateText: {
    id: `${scope}.translateText`,
    defaultMessage: 'Translate Text',
  },
  generateSummary: {
    id: `${scope}.generateSummary`,
    defaultMessage: 'Generate a Lesson for Summary',
  },
  generateTranslation: {
    id: `${scope}.generateTranslation`,
    defaultMessage: 'Generate Translation',
  },
  askAIAssistant: {
    id: `${scope}.askAIAssistant`,
    defaultMessage: 'Ask AI Assistant',
  },
  landingWelcomeMessage: {
    id: `${scope}.landingWelcomeMessage`,
    defaultMessage: 'Hello {givenName}, How can I help you today?',
  },
  caseStudyHeading: {
    id: `${scope}.caseStudyHeading`,
    defaultMessage: 'To develop a localized case study, fill in the following:',
  },
  caseStudyInputPlaceholder: {
    id: `${scope}.caseStudyInputPlaceholder`,
    defaultMessage: 'Add text',
  },
  caseStudyRegion: {
    id: `${scope}.caseStudyRegion`,
    defaultMessage: 'Region',
  },
  caseStudyDiscipline: {
    id: `${scope}.caseStudyDiscipline`,
    defaultMessage: 'Discipline',
  },
  caseStudyTopic: {
    id: `${scope}.caseStudyTopic`,
    defaultMessage: 'Topic',
  },
  featureBoxHeading: {
    id: `${scope}.featureBoxHeading`,
    defaultMessage: 'To develop a localized feature box, fill in the following:',
  },
  featureBoxDiscipline: {
    id: `${scope}.featureBoxDiscipline`,
    defaultMessage: 'Discipline',
  },
  featureBoxKeyConcept: {
    id: `${scope}.featureBoxKeyConcept`,
    defaultMessage: 'Key Concept',
  },
  featureBoxRegion: {
    id: `${scope}.featureBoxRegion`,
    defaultMessage: 'Region',
  },
  duplicateScreenError: {
    id: `${scope}.duplicateScreenError`,
    defaultMessage: 'Cannot paste invalid courseware item.',
  },
});
